import classes from './AddAttachmentsBulkV2.module.scss'
import { TabPanel, TabView } from 'primereact/tabview'
import { Button } from 'primereact/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCloudUpload,
  faPlus,
  faCircleCheck,
  faXmark,
  faTrash,
  faCircleExclamation,
  faInfoCircle,
  faLink,
  faSpinner,
  faRefresh,
  faQrcode,
  faPaperclip,
} from '@fortawesome/free-solid-svg-icons'
import { useDropzone } from 'react-dropzone'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { classNames } from 'primereact/utils'
import { saveAs } from 'file-saver'
import CertificateListService from '../../../../../services/CertificateListService'
import {
  validFileName,
  validFileSize,
  validFileType,
} from '../../../../../utils/helpers/file-validation.helpers'
import { filterValidSelectedAttachments } from '../../../../../utils/helpers/attachment-selection.helpers'
import {
  CertificateDocumentTypeV2,
  ECMContentType,
} from '../../../../../enums/CertificateDocumentType'
import { CertificateDocumentStatus } from '../../../../../enums/CertificateDocumentStatus'
import { Tooltip } from 'primereact/tooltip'
import EcmIntegrationService from '../../../../../services/EcmIntegrationService'
import ConfirmationModal from '../../../../../shared/confirmation-modal/ConfirmationModal'
import useToastr from '../../../../../hooks/useToastr'
import { ConfirmDialog } from 'primereact/confirmdialog'
import clsx from 'clsx'
import { copyText } from '../../../../../utils/helpers/clipboard.helpers'
import {
  selectAttachmentUpdatedList,
  selectCertDetailValues,
  selectProdDetailValues,
  updateAttachmentList,
  selectToggleServiceRequest,
  selectCertificateAction,
} from '../../../../../features/createCertificate/createCertificateSlice'
import { TestReportMatchedFoundFileAssociatedCertificateModel } from '../../../../../shared/models/TestReportMatchedFoundFile.model'
import { CertificateEditDataModel } from '../../../../../shared/models/CertificateEditData.model'
import CategoryTemplate from './category-template-list/CategoryTemplate'
import {
  CategoryType,
  ICategoryType,
  InspectionCategoryList,
  R2CCategoryList,
  TestReportCategoryList,
} from '../../../../../enums/CetificateFileCategoryType'
import {
  attachmentTabs,
  getAttachmentFileName,
  getCategoryDescription,
  getContentType,
  getContentTypeByCategory,
  getContentTypeDescription,
} from '../../../../../utils/constants/certificate-attachment.constants'
import { faEdit } from '@fortawesome/free-regular-svg-icons'
import AddAttachmentBulkCategoryEditDialog from './add-attachments-bulk-category-edit-dialog/AddAttachmentsBulkCategoryEditDialog'
import { orderBy } from 'lodash'
import ContentTypeTemplate from './content-type-template-list/ContentTypeTemplate'
import {
  CertificateTypeList,
  IContentType,
  TestReportTypeList,
} from '../../../../../enums/CetificateFileContentType'
import {
  getAttributeUniqueName,
  CertificateGroupEnum,
  UnlinkEcmBtnText,
  LinkToWbBtnText,
  displayUnlinkEcmModalHeader,
  CERTIFICATE_DOCUMENT_TYPE_ALLOWED_LINK,
} from '../../../../../utils/constants/certificate.constants'
import {
  ecmUnavailableHeader,
  ecmUnavailableMessage,
} from '../../../../../utils/constants/ecm.constants'
import CertificateDetailsRPLinkButton from '../../certificate-details/certificate-details-rp-attachments/certificate-details-rp-link-button/CertificateDetailsRPLinkButton'
import { RPAttachmentLinkButtonEnum } from '../rp-library/shared/constants/AddAttachmentsRPConstants'
import { IConfirmationModalProps } from '../rp-library/shared/interfaces/non-model/IConfirmationModalProps'
import { IEcmCertificateDocumentActionRequest } from '../rp-library/shared/interfaces/IEcmCertificateDocument'
import useCertificateDocument from '../../../../../hooks/useCertificateDocument'
import { SplitButton } from 'primereact/splitbutton'
import { useCertificateQrCodeGenerator } from '../../../hooks/useCertificateQrCodeGenerator'
import { v4 as uuidv4 } from 'uuid'

export interface IAttachmentBulkFileObject {
  id?: string
  group_index: CertificateDocumentTypeV2
  isValid: boolean
  file?: File
  name: string
  fileResult: string
  status: CertificateDocumentStatus
  ecmFileNodeId?: string
  isDeleted: boolean
  isShowInUi: boolean
  ecmNodeId: string
  associatedCertificates: TestReportMatchedFoundFileAssociatedCertificateModel[]
  ecmContentType?: ECMContentType
  category?: CategoryType
  tempUniqueId: string
}

interface IAttachmentObject {
  id: string
  name: string
  ecmFileNodeId: string
  status: string
  group_index: string
}

type SelectedAttachmentsByTab = Partial<Record<CertificateDocumentTypeV2, IAttachmentBulkFileObject[]>>

const initialConfirmationModalValues: IConfirmationModalProps = {
  onConfirm: () => { },
  onCancel: () => { },
  visible: false,
  headerDisplay: '',
  buttonNoDisplay: 'No',
  buttonYesDisplay: 'Yes',
  confirmationMessageHTML: '',
  style: undefined,
  isSaving: undefined,
}

const workbenchDocumentLinkUrl = process.env.REACT_APP_WORKBENCH_DOCUMENT_URL
const maxValidFileCount: number = 35

const AddAttachmentsBulkV2 = (props: any) => {
  const {
    setAttachments,
    setOutputAttachmentValues,
    inputAttachments,
    hasAttachmentLabel,
    testReportsValidatorHook,
    details,
    setIsAttachmentsValid,
    isEditOrModify,
    certificateId,
    isCertificateFromRevision,
    currentStep,
    uniqueCertificateId
  } = props
  const dispatch = useDispatch()
  const certificateDocumentHook = useCertificateDocument()
  const attachmentUpdateListFromRedux = useSelector(selectAttachmentUpdatedList)
  const toggleServiceRequest = useSelector(selectToggleServiceRequest)
  const [uploadFileList, setUploadFileList] = useState<Array<any>>([[], [], [], [], []])
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [updatedAttachmentTabs, setUpdatedAttachmentTabs] = useState(attachmentTabs)
  const [activeDocumentType, setActiveDocumentType] = useState(
    CertificateDocumentTypeV2.Certificate
  )
  const [tooltipEcmNodeId, setTooltipEcmNodeId] = useState('Click to Copy')
  const [showDeleteFileConfirmation, setShowDeleteFileConfirmation] = useState(false)
  const [showMaxFileConfirmation, setShowMaxFileConfirmation] = useState(false)
  const [fileToDelete, setFileToDelete] = useState(0)
  const [hasReachedMaxValidFileCount, setHasReachedMaxValidFileCount] = useState(false)
  const [selectedAttachment, setSelectedAttachment] = useState<SelectedAttachmentsByTab>({})

  const { showSuccess, showError, showInfo } = useToastr()
  const productDetailsValues = useSelector(selectProdDetailValues)
  const certificateDetailsValues = useSelector(selectCertDetailValues)
  const [isBulkEditDialogShow, setIsBulkEditDialogShow] = useState(false)
  const [isDeletingInProgress, setIsDeletingInProgress] = useState<boolean>(false)
  const [isSyncAttachmentLoading, setIsSyncAttachmentLoading] = useState(false)
  const hasEditableContentType = [
    CertificateDocumentTypeV2.Certificate,
    CertificateDocumentTypeV2.TestReport,
  ]

  const [disableBulkButtons, setDisableBulkButtons] = useState<Record<string, boolean>>({})

  const [displayUnlinkEcmModalPrompt, setDisplayUnlinkEcmModalPrompt] = useState(false)
  const currentSelectedAttachment = selectedAttachment[activeDocumentType] ?? []
  const currentDisableBulkButtons = disableBulkButtons[activeDocumentType] ?? false
  const unlinkCount = currentSelectedAttachment.filter(row => row.status === CertificateDocumentStatus.LinkedToWbAndEcmTic).length
  const linkCount = currentSelectedAttachment.filter(row => row.status === CertificateDocumentStatus.SavedInEcmTic).length

  const certificateAction = useSelector(selectCertificateAction)
  const qrCodeGenerator = useCertificateQrCodeGenerator({
    certificateType: certificateDetailsValues.formValues?.certificate_certificateType,
    parties: [
      {
        partySiteNumber: certificateDetailsValues.formValues?.partytype_brandOwner,
        relationshipType: 'Brand Owner',
      },
    ],
  })

  const [confirmationModalProps, setConfirmationModalProps] = useState<IConfirmationModalProps>(
    initialConfirmationModalValues
  )

  const [confirmBulkModalProps, setConfirmBulkModalProps] = useState<IConfirmationModalProps>(
    initialConfirmationModalValues
  )

  const [isShowBulkDialog, setIsShowBulkDialog] = useState(false)
  const [bulkAction, setBulkAction] = useState<'link' | 'unlink' | null>(null);

  useEffect(() => {
    if (!isEditOrModify) {
      setUploadFileList([[], [], [], [], []])
    }
  }, [toggleServiceRequest])

  const FileUploadSuccessMessages = {
    FileUploadReadyToLinkWB: `File has been uploaded successfully and ready to link in WB and ECM TIC.`,
    FileUploadReadyToLinkECM: `File has been uploaded successfully and ready to link in ECM TIC.`,
    FileUploadSuccessful: `File has been uploaded successfully.`,
  }

  const syncSelectedRowsForCurrentTab = (rows: IAttachmentBulkFileObject[]) => {
    setSelectedAttachment(prev => {
      const currentSelection = prev[activeDocumentType] ?? []
      const validSelection = filterValidSelectedAttachments(currentSelection, rows)

      if (validSelection.length === currentSelection.length) return prev

      return {
        ...prev,
        [activeDocumentType]: validSelection,
      }
    })
  }

  useEffect(() => {
    syncSelectedRowsForCurrentTab(uploadFileList[activeDocumentType] ?? [])
  }, [uploadFileList, activeDocumentType])

  const getTotalValidUploadCount = () => {
    return uploadFileList
      .flat()
      .filter((file: IAttachmentBulkFileObject) => file.isValid == true && file.id == '').length
  }

  const onAttachedFiles = (forAttachedFiles: IAttachmentBulkFileObject[]) => {
    const prevUploadFileList: any = uploadFileList.map((attachmentGroup: any) => attachmentGroup)
    if (prevUploadFileList) prevUploadFileList[activeDocumentType].unshift(...forAttachedFiles)

    setUploadFileList(prevUploadFileList)
    sendAttachmentValuesToParent(prevUploadFileList)
  }

  const validateTestReport = async (files: IAttachmentBulkFileObject[]) => {
    let ownerReference =
      certificateDetailsValues.formValues?.[
      getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
      ] ??
      details.editData.find(
        (data: CertificateEditDataModel) =>
          data.attribute_unique_name ===
          getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')
      ).value[0]

    let scheme =
      (certificateDetailsValues.formValues &&
        certificateDetailsValues.formValues[
        getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateType')
        ]) ??
      details.certificateScheme

    let baseModel = productDetailsValues?.modelList?.find(
      (model: any) => model.isBaseModel
    )?.modelName

    if (!baseModel) {
      if (productDetailsValues?.modelList?.length > 0) {
        baseModel = productDetailsValues.modelList[0].modelName
      }
    }
    let filesToValidate = files.map(file => file.name)

    return await testReportsValidatorHook.validateTestReports(
      filesToValidate,
      ownerReference,
      scheme,
      baseModel
    )
  }

  const attachFiles = async (incomingFiles: File[], defaultContentType?: ECMContentType) => {
    let newFileList: IAttachmentBulkFileObject[] = []
    const documentType: CertificateDocumentTypeV2 = activeDocumentType as CertificateDocumentTypeV2
    const currentValidFileCount = getTotalValidUploadCount()

    incomingFiles.forEach((file: File, index: number) => {
      const fileObject: any = {}
      fileObject.category =
        documentType == CertificateDocumentTypeV2.TestReport
          ? CategoryType.TestReport
          : CategoryType.None
      fileObject.id = ''
      fileObject.file = file
      fileObject.ecmContentType = defaultContentType || getContentType(documentType)
      fileObject.name = getAttachmentFileName(
        file.name,
        documentType,
        fileObject.category,
        fileObject.ecmContentType
      )
      fileObject[`group_index`] = documentType
      fileObject.status = CertificateDocumentStatus.NotYetUploaded
      fileObject.tempUniqueId = uuidv4()
      validateFile(fileObject, uploadFileList[activeDocumentType], false)
      newFileList.unshift(fileObject)
    })

    const incomingValidFileCount = newFileList.filter(
      (file: IAttachmentBulkFileObject) => file.isValid == true
    ).length

    if (currentValidFileCount == maxValidFileCount) {
      return
    } else if (incomingValidFileCount + currentValidFileCount > maxValidFileCount) {
      setShowMaxFileConfirmation(true)
    } else {
      newFileList.forEach(fileObject => {
        validateFile(fileObject, uploadFileList[activeDocumentType])
      })

      await processDuplicateTestReport(documentType, newFileList)
      onAttachedFiles(newFileList)
    }
  }

  const processDuplicateTestReport = async (
    documentType: CertificateDocumentTypeV2,
    prevUploadFileList: any
  ) => {
    if (documentType == CertificateDocumentTypeV2.TestReport) {
      const validationResult = await validateTestReport(
        prevUploadFileList.filter(
          (x: IAttachmentBulkFileObject) =>
            x.status !== CertificateDocumentStatus.LinkedToWbAndEcmTic &&
            x.status !== CertificateDocumentStatus.SavedInEcmTic
        )
      )

      if (validationResult?.hasDuplicate) {
        prevUploadFileList.forEach((newFile: IAttachmentBulkFileObject) => {
          var matchedTestReport = validationResult.matchedTestReports?.find(
            (attachment: any) =>
              attachment.name == newFile.name &&
              newFile.status !== CertificateDocumentStatus.LinkedToWbAndEcmTic
          )

          if (matchedTestReport) {
            newFile.ecmNodeId = matchedTestReport.ecmNodeId
            newFile.status = matchedTestReport.isInEcmTic
              ? CertificateDocumentStatus.TestReportDuplicate
              : CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed

            newFile.associatedCertificates = matchedTestReport.associatedCertificates
          }
        })
      } else {
        prevUploadFileList.forEach((newFile: IAttachmentBulkFileObject) => {
          if (newFile.id == '') {
            newFile.ecmNodeId = ''
            newFile.status = CertificateDocumentStatus.NotYetUploaded
            newFile.associatedCertificates = []
          }
        })
      }
    }
  }

  const checkHasReachMaxValidFileCount = () => {
    const currentValidFileCount = getTotalValidUploadCount()

    if (currentValidFileCount >= maxValidFileCount) setHasReachedMaxValidFileCount(true)
    else setHasReachedMaxValidFileCount(false)
  }

  const sendAttachmentValuesToParent = (fileList: any) => {
    if (setOutputAttachmentValues) {
      setOutputAttachmentValues(fileList)
    }
  }

  const searchAndLinkClick = () => {
    window.open(`${workbenchDocumentLinkUrl}${certificateId}`, '_blank')
  }

  const { acceptedFiles, getRootProps, getInputProps, isDragActive, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    onDrop: incomingFiles => attachFiles(incomingFiles),
  })

  const handleAttachQrCode = async () => {
    const zipFile = await qrCodeGenerator.createZipFile()
    attachFiles([zipFile], ECMContentType.ConformityMarking)
    showSuccess('File Attached!', 'Attachment completed successfully.')
  }

  const renderDropzoneActive = () => {
    return (
      <>
        {isDragActive && !hasReachedMaxValidFileCount && (
          <div className={classes['attachment-dropzone']}>
            <div className={classes['attachment-dropzone-content']}>
              <div className={classes['attachment-dropzone-content-icon']}>
                <FontAwesomeIcon icon={faCloudUpload} size="2x" />
              </div>
              <div className={classes['attachment-dropzone-content-text']}>
                Drop files for upload
              </div>
            </div>
          </div>
        )}
        {isDragActive && hasReachedMaxValidFileCount && (
          <div className={`${classes['attachment-dropzone']} ${classes['invalid']}`}>
            <div className={classes['attachment-dropzone-content']}>
              <div className={classes['attachment-dropzone-content-icon']}>
                <FontAwesomeIcon icon={faCircleExclamation} size="2x" />
              </div>
              <div className={classes['attachment-dropzone-content-text']}>
                Maximum valid uploaded files of {maxValidFileCount} has been reached for this
                transaction.
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  const renderAddFileHeader = () => {
    const isInternalTab = activeDocumentType === CertificateDocumentTypeV2.InternalFiles

    return (
      !isInternalTab && (
        <div className={classes['attachment-add-file-container']}>
          <input {...getInputProps()} />
          <div className={classes['attachment-add-file-buttons-container']}>
            <div className={classNames(classes['left-section'], 'shrink-0')}>
              {(activeDocumentType === CertificateDocumentTypeV2.Certificate ||
                activeDocumentType === CertificateDocumentTypeV2.TestReport) && (
                  <span>
                    <i>
                      <strong>NOTE:</strong> Documents Uploaded to ECM and linked to WB in this tab
                      are visible to the Customer
                    </i>
                  </span>
                )}

              {(activeDocumentType === CertificateDocumentTypeV2.R2CPackage ||
                activeDocumentType === CertificateDocumentTypeV2.InspectionSurveillance) && (
                  <span>
                    <i>
                      <strong>NOTE:</strong> Documents Uploaded to ECM and linked to WB in this tab
                      are not visible to the Customer
                    </i>
                  </span>
                )}

              <div className={classes['legends']}>
                <div className={classes['legend']}>
                  <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['icon-1']} />
                  <span className={classes['legend-label']}>Linked/Saved to WB & ECM TIC</span>
                </div>
                <div className={classes['legend']}>
                  <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['icon-2']} />
                  <span className={classes['legend-label']}>Saved in ECM TIC</span>
                </div>
                <div className={classes['legend']}>
                  <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['icon-3']} />
                  <span className={classes['legend-label']}>
                    Ready to Link/Save to WB & ECM TIC
                  </span>
                </div>
              </div>
            </div>
            <div className={classNames(classes['right-section'], 'flex-wrap')}>
              {hasReachedMaxValidFileCount && (
                <span className={classes['invalid-add-file-info']}>
                  Maximum valid uploaded files of {maxValidFileCount} has been reached for this
                  transaction.
                </span>
              )}
              {isEditOrModify && (
                <div>
                  <span
                    title={
                      !isSyncAttachmentLoading
                        ? 'Sync Document(s) from Workbench'
                        : 'Ongoing Syncing of Document(s)'
                    }
                  >
                    <Button
                      className={`ul-button -small ${classes['sync-btn']}`}
                      onClick={() => {
                        syncProcess()
                      }}
                      disabled={isSyncAttachmentLoading}
                    >
                      {isSyncAttachmentLoading ? (
                        <FontAwesomeIcon
                          icon={faSpinner}
                          size="sm"
                          spin={isSyncAttachmentLoading}
                        />
                      ) : (
                        <FontAwesomeIcon icon={faRefresh} size="sm" />
                      )}
                    </Button>
                  </span>
                  <button
                    className={`ul-button -app-primary ${classes['app-button-primary-inverted']} -small`}
                    onClick={searchAndLinkClick}
                  >
                    Search and Link in Workbench
                    <FontAwesomeIcon icon={faLink} size="lg" style={{ paddingLeft: '0.3rem' }} />
                  </button>
                </div>
              )}
              {activeDocumentType === CertificateDocumentTypeV2.Certificate &&
                qrCodeGenerator.isSchemeSupported &&
                !certificateAction.isWithdraw && (
                  <SplitButton
                    buttonTemplate={
                      <>
                        <FontAwesomeIcon icon={faPaperclip} /> Attach QR Code
                      </>
                    }
                    className="-small min-h-[2.225rem]"
                    buttonClassName={classNames(
                      'ul-button -small !bg-[#0088cc] !border-0',
                      classes.attachQrCodeButton
                    )}
                    menuButtonClassName="rounded-l-none ul-button -small !bg-[#0088cc] !border-0 !shadow-none"
                    onClick={handleAttachQrCode}
                    disabled={qrCodeGenerator.isDisabled}
                    model={[
                      {
                        template: (_, { onClick }) => {
                          return (
                            <div
                              className="py-3 px-4 cursor-pointer hover:bg-gray-100"
                              onClick={onClick}
                            >
                              <FontAwesomeIcon icon={faQrcode} /> Generate QR Code
                            </div>
                          )
                        },
                        command: () => {
                          console.log('Clicked download')
                          qrCodeGenerator.downloadZip()
                        },
                      },
                    ]}
                  />
                )}
              <button
                className="ul-button -app-primary -small"
                onClick={open}
                disabled={hasReachedMaxValidFileCount}
              >
                <FontAwesomeIcon icon={faPlus} size="lg" />
                Add File
              </button>
            </div>
          </div>
        </div>
      )
    )
  }

  const renderEmptyDatatable = () => {
    return (
      <div className={classes['datatable-emptymessage-container']}>
        <FontAwesomeIcon icon={faCloudUpload} size="lg" />

        <div className={classes['datatable-emptymessage-label']}>Drag and Drop Files here</div>
      </div>
    )
  }

  const columnList: any[] = []

  const tableColumnHeader = (col: any) => (
    <div>
      <span title={col.header}>{col.header}</span>
    </div>
  )

  const tableColumnBody = (rowData: any, col: any) => {
    const stockClassName = classNames({
      'text-overflow-ellipsis': true,
    })
    return (
      <div title={rowData[col.field]} className={stockClassName}>
        {rowData[col.field]}
      </div>
    )
  }

  const renderDynamicColumns = columnList.map((col: any) => {
    return (
      <Column
        key={col.field}
        field={col.field}
        header={tableColumnHeader(col)}
        style={{ flexGrow: 1, flexBasis: col.width, width: col.width }}
        body={tableColumnBody.bind(col)}
      />
    )
  })

  const gridFileNameTemplate = (rowData: any) => {
    const stockClassName = classNames(classes['grid-filename'])
    return (
      <div title={rowData.name} className={stockClassName}>
        {rowData.id != '' && (
          <a className={classes['link']} onClick={() => downloadFile(rowData)}>
            {rowData.name}
          </a>
        )}
        {rowData.id == '' && (
          <span
            className={
              !rowData.isValid ||
                rowData.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed
                ? classes['error']
                : ''
            }
          >
            {rowData.name}
          </span>
        )}
      </div>
    )
  }
  const gridHeaderStatusIconTemplate = () => {
    return <div style={{ minHeight: '22px' }}></div>
  }
  const gridStatusIconTemplate = (rowData: any, props: any) => {
    const inProgressTooltip =
      rowData.status == CertificateDocumentStatus.UnlinkingInProgress
        ? 'Unlinking in progress'
        : 'Uploading in progress'

    return (
      <div style={{ width: '100%', textAlign: 'center' }}>
        {rowData.status == CertificateDocumentStatus.LinkedToWbAndEcmTic && (
          <div className={`tooltip-status-target${props.rowIndex}`}>
            <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['icon-1']} />
            <Tooltip
              target={`.tooltip-status-target${props.rowIndex}`}
              className="custom-tooltip"
              position="right"
            >
              <div>Linked/Saved to WB & ECM TIC</div>
            </Tooltip>
          </div>
        )}
        {rowData.status == CertificateDocumentStatus.SavedInEcmTic && (
          <div className={`tooltip-status-target${props.rowIndex}`}>
            <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['icon-2']} />
            <Tooltip
              target={`.tooltip-status-target${props.rowIndex}`}
              className="custom-tooltip"
              position="right"
            >
              <div>Saved in ECM TIC</div>
            </Tooltip>
          </div>
        )}
        {rowData.status == CertificateDocumentStatus.ReadyToLinkToWbAndEcmTic && (
          <div className={`tooltip-status-target${props.rowIndex}`}>
            <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['icon-3']} />
            <Tooltip
              target={`.tooltip-status-target${props.rowIndex}`}
              className="custom-tooltip"
              position="right"
            >
              <div>Ready to Link/Save to WB & ECM TIC</div>
            </Tooltip>
          </div>
        )}
        {rowData.status == CertificateDocumentStatus.TestReportDuplicate && rowData.id && (
          <div className={`tooltip-status-target${props.rowIndex}`}>
            <FontAwesomeIcon icon={faCircleCheck} size={'xs'} className={classes['icon-3']} />
            <Tooltip
              target={`.tooltip-status-target${props.rowIndex}`}
              className="custom-tooltip"
              position="right"
            >
              <div>Ready to Link/Save to WB & ECM TIC</div>
            </Tooltip>
          </div>
        )}

        {rowData.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed &&
          rowData.id && (
            <div className={`tooltip-status-target${props.rowIndex}`}>
              <FontAwesomeIcon icon={faInfoCircle} size={'xs'} className={classes['icon-4']} />
              <Tooltip
                target={`.tooltip-status-target${props.rowIndex}`}
                className="custom-tooltip"
                position="right"
              >
                <div>
                  File already exists in ECM TIC. Please continue processing the linking of file.
                </div>
              </Tooltip>
            </div>
          )}

        {(rowData.status == CertificateDocumentStatus.UnlinkingInProgress ||
          rowData.status == CertificateDocumentStatus.UploadToEcmInProgress) && (
            <div className={`tooltip-status-target${props.rowIndex}`}>
              <FontAwesomeIcon icon={faSpinner} size={'xs'} spin={true} />
              <Tooltip
                target={`.tooltip-status-target${props.rowIndex}`}
                className="custom-tooltip"
                position="right"
              >
                <div>{inProgressTooltip}</div>
              </Tooltip>
            </div>
          )}
      </div>
    )
  }

  const gridEcmNodeIdTemplate = (rowData: any) => {
    return rowData.status == CertificateDocumentStatus.TestReportDuplicate ||
      rowData.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed ? (
      <></>
    ) : (
      <>
        {rowData.ecmFileNodeId && (
          <div className="tooltip-ecmfilenode-target">
            <a
              onClick={() => {
                copyText(rowData.ecmFileNodeId)
                setTooltipEcmNodeId('Copied!')
              }}
              onMouseOver={() => setTooltipEcmNodeId('Click to Copy')}
            >
              {rowData.ecmFileNodeId}
            </a>

            <Tooltip
              target=".tooltip-ecmfilenode-target"
              className="custom-tooltip"
              position="right"
            >
              <div>{tooltipEcmNodeId}</div>
            </Tooltip>
          </div>
        )}
      </>
    )
  }

  const gridStatusTemplate = (rowData: any, props: any) => {
    const stockClassName = clsx(
      {
        'text-overflow-ellipsis': true,
      },
      classes['gridaction-container']
    )

    const statusClassName = clsx(classes['fileresult'], {
      [classes['success']]:
        rowData.isValid &&
        rowData.status != CertificateDocumentStatus.TestReportDuplicate &&
        rowData.status != CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed,

      [classes['warning']]:
        rowData.status === CertificateDocumentStatus.TestReportDuplicate &&
        rowData.isValid === true,
      [classes['error']]:
        !rowData.isValid ||
        rowData.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed,
    })
    let status = ''
    switch (rowData.status) {
      case CertificateDocumentStatus.TestReportDuplicate:
        const hasAnotherDuplicateFileTestReport = 'Duplicate file already exists.'

        const containsDuplicateFileExistsText =
          rowData.fileResult?.indexOf(hasAnotherDuplicateFileTestReport) === 0

        if (!containsDuplicateFileExistsText) {
          status =
            'This Report already exists in ECM TIC. Please link the existing Report or remove this file.'
        } else {
          status = rowData.fileResult
        }

        break
      case CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed:
      case CertificateDocumentStatus.LinkedToWbAndEcmTic:
        status = ''
        break
      default:
        status = rowData.fileResult
    }

    return (
      <div className={stockClassName} title={status}>
        <span className={statusClassName}>{status}</span>
      </div>
    )
  }

  const gridContentTypeTemplate = (rowData: any) => {
    const stockClassName = clsx(
      {
        'text-overflow-ellipsis': true,
      },
      classes['grid-content-type']
    )
    const hasEcmFileNodeId = rowData?.ecmFileNodeId != null
    let list: IContentType[]

    if (activeDocumentType === CertificateDocumentTypeV2.Certificate) list = CertificateTypeList
    else list = TestReportTypeList

    const contentTypeDescription = getContentTypeDescription(rowData)

    return (
      <>
        {hasEditableContentType.includes(activeDocumentType) && !hasEcmFileNodeId ? (
          <ContentTypeTemplate
            activeDocumentType={activeDocumentType}
            rowData={rowData}
            list={list}
          />
        ) : (
          <div className={stockClassName} title={contentTypeDescription}>
            <span
              className={
                (rowData.id === '' && !rowData.isValid) ||
                  rowData.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed
                  ? classes['error']
                  : ''
              }
            >
              {contentTypeDescription}
            </span>
          </div>
        )}
      </>
    )
  }

  const gridCategoryTemplate = (rowData: IAttachmentBulkFileObject) => {
    const stockClassName = clsx(classes['grid-category-type'])
    let categoryList: ICategoryType[]

    if (activeDocumentType === CertificateDocumentTypeV2.TestReport)
      categoryList = TestReportCategoryList
    else if (activeDocumentType === CertificateDocumentTypeV2.R2CPackage)
      categoryList = R2CCategoryList
    else categoryList = InspectionCategoryList

    let categoryDescription = getCategoryDescription(
      rowData.category ? rowData.category : CategoryType.None,
      rowData.group_index
    )

    return (
      <>
        <div className={stockClassName} title="Category"></div>
        {rowData?.ecmFileNodeId == null && (
          <CategoryTemplate
            activeDocumentType={activeDocumentType}
            rowData={rowData}
            categoryList={categoryList}
            refreshTable={refreshTable}
            uploadFileList={uploadFileList}
          />
        )}

        {rowData.ecmFileNodeId != null && (
          <div className={stockClassName} title={categoryDescription}>
            <span
              className={
                (rowData.id === '' && !rowData.isValid) ||
                  rowData.status == CertificateDocumentStatus.TestReportDuplicateLinkToEcmFailed
                  ? classes['error']
                  : ''
              }
            >
              {categoryDescription}
            </span>
          </div>
        )}
      </>
    )
  }

  const gridActionTemplate = (rowData: any, props: any) => {
    const icon = faLink
    const { label, buttonType, documentAction } =
      rowData.status === CertificateDocumentStatus.SavedInEcmTic
        ? {
          label: LinkToWbBtnText,
          buttonType: RPAttachmentLinkButtonEnum.linkToWb,
          documentAction: handleLinkToWb,
        }
        : {
          label: UnlinkEcmBtnText,
          buttonType: RPAttachmentLinkButtonEnum.unlinkEcm,
          documentAction: handleUnlinkConfirmationModalProps,
        }

    return (
      <div className={classes['gridaction-container']}>
        {(rowData.status == CertificateDocumentStatus.NotYetUploaded ||
          (rowData.status == CertificateDocumentStatus.TestReportDuplicate && !rowData.id)) && (
            <Button
              className="p-button-rounded p-button-secondary p-button-text p-button-sm"
              onClick={(e) => {
                e.preventDefault();
                deleteAttachment(props.rowIndex)
              }}
            >
              <FontAwesomeIcon icon={faXmark} />
            </Button>
          )}
        {(rowData.status == CertificateDocumentStatus.ReadyToLinkToWbAndEcmTic ||
          rowData.status == CertificateDocumentStatus.UploadToEcmFailed ||
          (rowData.status == CertificateDocumentStatus.TestReportDuplicate && rowData.id)) && (
            <Button
              className="p-button-rounded p-button-secondary p-button-text p-button-sm"
              title="Delete Attachment"
              onClick={(e) => {
                e.preventDefault()
                handleDeletAttachment(props.rowIndex)
              }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          )}

        {CERTIFICATE_DOCUMENT_TYPE_ALLOWED_LINK.includes(rowData.group_index) &&
          (rowData.status === CertificateDocumentStatus.LinkedToWbAndEcmTic ||
            rowData.status === CertificateDocumentStatus.SavedInEcmTic) &&
          isCertificateFromRevision && (
            <CertificateDetailsRPLinkButton
              label={label}
              icon={icon}
              linkButtonType={buttonType}
              onClick={() => {
                const file: IAttachmentObject = {
                  id: rowData.id,
                  ecmFileNodeId: rowData.ecmFileNodeId,
                  name: rowData.ecmFileName,
                  status: rowData.status,
                  group_index: rowData.group_index,
                }
                documentAction(file)
              }}
            />
          )}
      </div>
    )
  }
  const downloadFile = async (file: any) => {
    switch (file.status) {
      case CertificateDocumentStatus.LinkedToWbAndEcmTic:
      case CertificateDocumentStatus.SavedInEcmTic:
        await EcmIntegrationService.downloadEcmFile(file.ecmFileNodeId).then(response => {
          if (response) {
            saveAs(response, file.name)
          } else {
            showError(
              'Unable to Download File',
              'There is a problem while connecting to ECM Folder. Please try again later.'
            )
          }
        })
        break
      case CertificateDocumentStatus.ReadyToLinkToWbAndEcmTic:
        await CertificateListService.downloadCertificateDocument(file.id).then(response => {
          if (response) {
            saveAs(response, file.name)
          } else {
            showError('Error!', 'File does not exists.')
          }
        })
        break
    }
  }
  const refreshTable = () => {
    const prevUploadFileList: any = uploadFileList.map((attachmentGroup: any) => attachmentGroup)
    setUploadFileList(prevUploadFileList)
  }
  const deleteAttachment = (index: any) => {
    const prevUploadFileList: any = uploadFileList.map((attachmentGroup: any) => attachmentGroup)
    if (prevUploadFileList) {
      prevUploadFileList[activeDocumentType].splice(index, 1)
    }
    recheckInvalidFiles(prevUploadFileList[activeDocumentType])
    setUploadFileList(prevUploadFileList)
    sendAttachmentValuesToParent(prevUploadFileList)
  }

  const deleteConfirmationMessage = () => {
    return (
      <span>
        The document(s) will be deleted from GMAWB File Storage.
        <br />
        <br />
        Would you like to continue?
      </span>
    )
  }

  const maxFileDialogBody = () => {
    return (
      <>
        <div className="custom-confirm-dialog-body">
          <div className="custom-space-below">
            Allowed File Type: (JPG, JPEG, DOC, DOCX, XLS, XLSX, TXT, BMP, GIF, PDF, PNG, MSG, ZIP)
          </div>
          <div>
            Please upload {maxValidFileCount} or fewer valid file(s) types for this transaction.
          </div>
        </div>
      </>
    )
  }

  const maxFileFooter = () => {
    return (
      <>
        <div className="custom-confirm-dialog-footer">
          <button
            className="ul-button -medium default-cancel-button custom-confirm-dialog-reject-btn"
            onClick={() => setShowMaxFileConfirmation(false)}
          >
            CLOSE
          </button>
        </div>
      </>
    )
  }

  const handleDeletAttachment = (index: any) => {
    setFileToDelete(index)
    setShowDeleteFileConfirmation(true)
  }

  const handleDeleteFileToBlobStorage = async () => {
    const prevUploadFileList: any = uploadFileList.map((attachmentGroup: any) => attachmentGroup)

    if (!prevUploadFileList) return
    setIsDeletingInProgress(true)

    const file = prevUploadFileList[activeDocumentType][fileToDelete]
    CertificateListService.deleteFileFromBlob(file.id)
      .then(response => {
        if (!response?.isSuccess) {
          setShowDeleteFileConfirmation(false)
          showError('Error!', 'Attachment(s) has not been deleted.')
          setIsDeletingInProgress(false)
          return
        }

        showSuccess(
          'Success!',
          'Attachment(s) has been deleted successfully from GMAWB File Storage.'
        )

        prevUploadFileList[activeDocumentType].splice(fileToDelete, 1)

        if (setAttachments) {
          const flatAttachmentList = prevUploadFileList
            .flatMap((attachment: IAttachmentObject) => attachment)
            .filter((fileData: IAttachmentObject) => fileData.id != '')

          const fileList = flatAttachmentList.map((attachment: IAttachmentObject) => {
            return {
              id: attachment.id,
              originalFileName: attachment.name,
              ecmFileNodeId: attachment.ecmFileNodeId,
              status: attachment.status,
              documentType: attachment.group_index,
              tempUniqueId: attachment.id
            }
          })

          setAttachments(fileList)
        }
        recheckInvalidFiles(prevUploadFileList[activeDocumentType])
        setShowDeleteFileConfirmation(false)
        sendAttachmentValuesToParent(prevUploadFileList)
        setUploadFileList(prevUploadFileList)
        setIsDeletingInProgress(false)
      })

      .catch(error => {
        setShowDeleteFileConfirmation(false)
        showError('Error!', 'Attachment(s) has not been deleted.')
        setIsDeletingInProgress(false)
        return
      })
  }
  const isBulkEditIconEnabled = () => {
    return currentSelectedAttachment.some(
      (row: IAttachmentBulkFileObject) => row.ecmFileNodeId == null
    )
  }

  const contentTypeHeader = () => {
    return hasEditableContentType.includes(activeDocumentType) ? (
      <div className={`${classes['category-column-container']}`}>
        <span>
          Content Type <span style={{ color: 'red' }}>*</span>
        </span>
        <span className={`${classes['category-column-edit-icon']}`}>
          <FontAwesomeIcon
            title="Bulk Edit Category"
            icon={faEdit}
            style={{
              color: isBulkEditIconEnabled() ? '#000000' : '#A0A0A0',
            }}
            onClick={() => {
              if (isBulkEditIconEnabled()) setIsBulkEditDialogShow(true)
            }}
          />
        </span>
      </div>
    ) : (
      <span>Content Type</span>
    )
  }

  const categoryHeader = () => {
    return (
      <div className={`${classes['category-column-container']}`}>
        <span>
          Category <span style={{ color: 'red' }}>*</span>
        </span>
        <span className={`${classes['category-column-edit-icon']}`}>
          <FontAwesomeIcon
            title="Bulk Edit Category"
            icon={faEdit}
            style={{
              color: isBulkEditIconEnabled() ? '#000000' : '#A0A0A0',
            }}
            onClick={() => {
              if (isBulkEditIconEnabled()) setIsBulkEditDialogShow(true)
            }}
          />
        </span>
      </div>
    )
  }

  const validateUploadedFiles = () => {
    const filesWRequiredCategory = [...uploadFileList[3], ...uploadFileList[4]].filter(
      file => file.isValid
    )

    const filesWRequiredContentType = [...uploadFileList[0], ...uploadFileList[1]].filter(
      file => file.isValid
    )

    const isValid =
      filesWRequiredCategory.every(file => file.category != CategoryType.None) &&
      filesWRequiredContentType.every(file => file.ecmContentType != ECMContentType.None)
    setIsAttachmentsValid(isValid)
  }

  useEffect(() => {
    processInputAttachments(inputAttachments)
  }, [inputAttachments])

  const processInputAttachments = (inputAttachments: any) => {
    if (!inputAttachments) return

    let newFileList: IAttachmentBulkFileObject[] = []

    const currentUploadedListNotYetOnDB: any[] = uploadFileList.map((attachmentGroup: any) =>
      attachmentGroup.filter((file: any) => file.id == '')
    )

    inputAttachments.forEach((file: any, index: number) => {
      const fileObject: any = {}
      fileObject.id = file.id
      fileObject.name = file.originalFileName
      fileObject[`group_index`] = file.documentType
      fileObject.status = file.status
      fileObject.ecmFileNodeId = file.ecmFileNodeId
      fileObject.ecmContentType = file.ecmContentType
      fileObject.category = file.category
      fileObject.tempUniqueId = file.id
      fileObject.isValid = true
      newFileList.unshift(fileObject)
    })
    newFileList.unshift(...currentUploadedListNotYetOnDB.flat())
    const certificateAttachments = newFileList.filter(
      (file: IAttachmentBulkFileObject) =>
        file[`group_index`] == CertificateDocumentTypeV2.Certificate
    )

    const testReportAttachments = newFileList.filter(
      (file: IAttachmentBulkFileObject) =>
        file[`group_index`] == CertificateDocumentTypeV2.TestReport
    )

    const r2cPackageAttachments = newFileList.filter(
      (file: IAttachmentBulkFileObject) =>
        file[`group_index`] == CertificateDocumentTypeV2.R2CPackage
    )

    const inspectionSurveillanceAttachments = newFileList.filter(
      (file: IAttachmentBulkFileObject) =>
        file[`group_index`] == CertificateDocumentTypeV2.InspectionSurveillance
    )

    const internalAttachments = newFileList.filter(
      (file: IAttachmentBulkFileObject) =>
        file[`group_index`] == CertificateDocumentTypeV2.InternalFiles
    )

    const loadedAttachments = [
      certificateAttachments,
      testReportAttachments,
      internalAttachments,
      r2cPackageAttachments,
      inspectionSurveillanceAttachments,
    ]

    if (internalAttachments.length === 0) {
      setUpdatedAttachmentTabs(prev =>
        prev.filter(tab => tab.id !== CertificateDocumentTypeV2.InternalFiles)
      )
    }

    setUploadFileList(loadedAttachments)
    sendAttachmentValuesToParent(loadedAttachments)
  }

  const handleUpdateDocumentsStatus = (status: CertificateDocumentStatus, documentId: string) => {
    setAttachments((prevState: any) => {
      const newState = prevState.map((item: any) =>
        item.id === documentId ? { ...item, status: status } : item
      )

      return newState
    })
  }

  const handleUnlinkFileFromWB = async (toUnlinkDocuments: IAttachmentObject) => {
    if (!toUnlinkDocuments) return
    setConfirmationModalProps(initialConfirmationModalValues)

    const unlinkRequestProps: IEcmCertificateDocumentActionRequest = {
      certificateDocumentId: toUnlinkDocuments?.id,
      ecmFileNodeId: toUnlinkDocuments?.ecmFileNodeId,
      certificateId: certificateId,
      handleUpdateDocumentsStatus: handleUpdateDocumentsStatus,
    }

    await certificateDocumentHook.handleUnlinkToWb(unlinkRequestProps)
  }

  const handleLinkToWb = async (toLinkDocuments: IAttachmentObject) => {
    if (!toLinkDocuments) return

    const linkRequestProps: IEcmCertificateDocumentActionRequest = {
      certificateDocumentId: toLinkDocuments?.id,
      ecmFileNodeId: toLinkDocuments?.ecmFileNodeId,
      certificateId: certificateId,
      handleUpdateDocumentsStatus: handleUpdateDocumentsStatus,
    }

    await certificateDocumentHook.handleLinkToWb(linkRequestProps)
  }

  const handleUnlinkConfirmationModalProps = (toUnlinkDocuments: IAttachmentObject) => {
    setConfirmationModalProps(current => {
      return {
        ...current,
        headerDisplay: displayUnlinkEcmModalHeader,
        confirmationMessageHTML: displayUnlinkEcmModalText(),
        visible: true,
        onCancel: () => {
          setConfirmationModalProps(initialConfirmationModalValues)
        },
        onConfirm: () => {
          handleUnlinkFileFromWB(toUnlinkDocuments)
        },
      }
    })
  }

  const displayUnlinkEcmModalText = () => {
    return (
      <span>
        This change will not affect the document in ECM TIC.
        <br />
        <br />
        Are you sure you want to unlink the selected Document(s)?
      </span>
    )
  }

  useEffect(() => {
    checkHasReachMaxValidFileCount()
    validateUploadedFiles()
  }, [uploadFileList])

  useEffect(() => {
    checkHasReachMaxValidFileCount()
  }, [activeDocumentType])

  useEffect(() => {
    const updateAttachments = async () => {
      if (!attachmentUpdateListFromRedux) return

      const prevUploadFileList: any = uploadFileList.map(
        (attachmentGroup: IAttachmentBulkFileObject[]) => attachmentGroup
      )
      //Implement adjustment===
      for (let rowData of orderBy(prevUploadFileList[activeDocumentType], ['id'], ['desc'])) {
        for (let attachmentUpdate of attachmentUpdateListFromRedux) {
          if (rowData.tempUniqueId == attachmentUpdate.tempUniqueId) {
            if (attachmentUpdate.newValue != null && attachmentUpdate.newValue != undefined) {
              if (hasEditableContentType.includes(activeDocumentType))
                rowData.ecmContentType = attachmentUpdate.newValue
              else rowData.category = attachmentUpdate.newValue

              processRowDataUpdate(rowData, prevUploadFileList[activeDocumentType])
            }
          }
        }
      }

      recheckInvalidFiles(prevUploadFileList[activeDocumentType])

      //Test Report tab duplicate validation
      if (activeDocumentType === CertificateDocumentTypeV2.TestReport) {
        await processDuplicateTestReport(activeDocumentType, prevUploadFileList[activeDocumentType])
      }
      setUploadFileList(prevUploadFileList)
      dispatch(updateAttachmentList(null))
    }

    updateAttachments()
  }, [attachmentUpdateListFromRedux])

  const recheckInvalidFiles = (updatedFileList: IAttachmentBulkFileObject[]) => {
    //Loop files with error to check it still has error
    for (let rowData of updatedFileList) {
      if (!rowData.isValid && !rowData.id) {
        validateFile(rowData, updatedFileList)
      }
    }
  }

  const removePrefix = (name: string) => {
    // Pattern for removing Prefix and retain original name if prefix N/A
    return name.replace(/^[a-zA-Z]+_/, '')
  }

  const processRowDataUpdate = (
    rowData: IAttachmentBulkFileObject,
    updatedFiles: IAttachmentBulkFileObject[]
  ) => {
    const originalFile = rowData.file
    if (activeDocumentType === CertificateDocumentTypeV2.InspectionSurveillance)
      rowData.ecmContentType = getContentTypeByCategory(rowData.category || CategoryType.None)
    let fileName: string
    if (originalFile) fileName = originalFile.name
    else fileName = removePrefix(rowData.name)

    rowData.name = getAttachmentFileName(
      fileName,
      activeDocumentType,
      rowData.category || CategoryType.None,
      rowData.ecmContentType || ECMContentType.None
    )
    validateFile(rowData, updatedFiles)
  }

  const validateFile = (
    rowData: IAttachmentBulkFileObject,
    updatedFileList: IAttachmentBulkFileObject[],
    validateDuplicate: boolean = true
  ) => {
    let errorMessageList: Array<string> = []

    const uploadedFileInDocumentType = updatedFileList?.filter(
      (existingFile: IAttachmentBulkFileObject) =>
        existingFile.name == rowData.name &&
        existingFile.isValid == true &&
        rowData.tempUniqueId != existingFile.tempUniqueId
    )
    if (!validFileSize(rowData.file?.size)) {
      rowData.isValid = false
      errorMessageList.push(`File is too big`)
    }

    if (!validFileType(rowData.name)) {
      rowData.isValid = false
      errorMessageList.push(`File type not allowed`)
    }
    if (!validFileName(rowData.name)) {
      rowData.isValid = false
      errorMessageList.push(`Filename is invalid`)
    }
    const hasDuplicate = validateDuplicate && uploadedFileInDocumentType.length > 0

    if (hasDuplicate) {
      rowData.isValid = false
      errorMessageList.push(`Duplicate file already exists`)
    }
    if (errorMessageList.length > 0) errorMessageList.push(`Please upload other file.`)
    rowData.fileResult = errorMessageList.join(`. `)

    if (errorMessageList.length == 0) {
      rowData.isValid = true

      if (hasEditableContentType.includes(activeDocumentType))
        rowData.fileResult = FileUploadSuccessMessages.FileUploadReadyToLinkWB
      else if (activeDocumentType == CertificateDocumentTypeV2.InternalFiles)
        rowData.fileResult = FileUploadSuccessMessages.FileUploadSuccessful
      else rowData.fileResult = FileUploadSuccessMessages.FileUploadReadyToLinkECM
    }
  }


  const getClassForFilesOnEcm = (e: any) => {
    if (e.ecmFileNodeId != null) return classes['files-on-ecm']

    return ''
  }
  const syncProcess = async () => {
    setIsSyncAttachmentLoading(true)

    await CertificateListService.syncDocument(certificateId)
    const attachments =
      await CertificateListService.getCertificateDocumentsByUniqueCertificateId(certificateId)

    processInputAttachments(attachments?.data)
    setAttachments(attachments?.data)
    setIsSyncAttachmentLoading(false)
  }

  const isR2COrInspection = (tabId: CertificateDocumentTypeV2) =>
    tabId === CertificateDocumentTypeV2.R2CPackage ||
    tabId === CertificateDocumentTypeV2.InspectionSurveillance

  const getColumnWidthStyle = (
    tabId: CertificateDocumentTypeV2,
    {
      defaultMin,
      defaultMax,
      r2cInspectionMin,
      r2cInspectionMax,
    }: {
      defaultMin?: string
      defaultMax?: string
      r2cInspectionMin?: string
      r2cInspectionMax?: string
    }
  ) => {
    const isR2cOrInspection = isR2COrInspection(tabId)
    return {
      ...(isR2cOrInspection
        ? {
          ...(r2cInspectionMin && { minWidth: r2cInspectionMin }),
          ...(r2cInspectionMax && { maxWidth: r2cInspectionMax }),
        }
        : {
          ...(defaultMin && { minWidth: defaultMin }),
          ...(defaultMax && { maxWidth: defaultMax }),
        }),
    }
  }


  const actionHeaderTemplate = () => {
    const mapPayload = (files: IAttachmentBulkFileObject[]) => ({
      certificateNumber: certificateDetailsValues?.formValues?.['certificate_certificateName'] ?? details?.certificateNumber,
      documents: files.map(file => ({
        certificateDocumentId: file.id,
        ecmFileNodeId: file.ecmFileNodeId,
        isTestReportDuplicate: false,
        workbenchCertificateId: certificateId,
      }))
    });

    const updateStatusOptimistic = (
      allowedStatus: CertificateDocumentStatus,
      inProgressStatus: CertificateDocumentStatus
    ) => {
      setAttachments((prev: IAttachmentBulkFileObject[]) =>
        prev.map(item => {
          if (
            currentSelectedAttachment.some(f => f.id === item.id) &&
            item.status === allowedStatus
          ) {
            return { ...item, status: inProgressStatus };
          }
          return item;
        })
      );
    };

    const applyResultUpdate = (updatedAttachments: any[]) => {
      const updatedIds = updatedAttachments.map(f => f.id);

      setAttachments((prev: any[]) =>
        prev.map(item => {
          if (updatedIds.includes(item.id)) {
            const doc = updatedAttachments.find(f => f.id === item.id);
            return { ...item, status: doc?.status ?? item.status };
          }
          return item;
        })
      );
    };


    const revertStatus = (files: any[]) => {
      setAttachments((prev: any[]) =>
        prev.map(doc => {
          const original = files.find(f => f.id === doc.id);
          return original ? { ...doc, status: original.status } : doc;
        })
      );
    };


    const executeBulkAction = async (type: string) => {
      setDisableBulkButtons(prev => ({
        ...prev,
        [activeDocumentType]: true,
      }));

      const isUnlink = type === 'unlink';
      const currentSelection = selectedAttachment[activeDocumentType] ?? []

      const filtered = currentSelection.filter(file =>
        isUnlink
          ? file.status === CertificateDocumentStatus.LinkedToWbAndEcmTic
          : file.status === CertificateDocumentStatus.SavedInEcmTic
      );

      const payload = mapPayload(filtered);

      showInfo(
        'Document Linking/Unlinking in Progress',
        'Documents are being linked to/unlinked from Workbench. You will receive a notification once completed.'
      )

      updateStatusOptimistic(
        isUnlink
          ? CertificateDocumentStatus.LinkedToWbAndEcmTic
          : CertificateDocumentStatus.SavedInEcmTic,
        isUnlink
          ? CertificateDocumentStatus.UnlinkingInProgress
          : CertificateDocumentStatus.UploadToEcmInProgress
      );

      try {
        setIsShowBulkDialog(false);
        setConfirmBulkModalProps(initialConfirmationModalValues)
        const result = isUnlink
          ? await CertificateListService.bulkUnlinkEcmDocument(payload)
          : await CertificateListService.bulkLinkEcmDocument(payload);

        if (!result.isSuccess) {
          showError("Unable to Process Linking/Unlinking to Workbench",
            "Linking/Unlinking of documents could not be completed because Workbench is currently unavailable. Please Try again once Workbench is back online (see status bar)."
          )
        }

        applyResultUpdate(result.data);
      }
      catch (err) {
        showError(
          "Network Error",
          "Failed to process request. Please check your connection and try again."
        );

        revertStatus(filtered);
      }
      finally {
        setDisableBulkButtons(prev => ({
          ...prev,
          [activeDocumentType]: false,
        }));
        setSelectedAttachment(prev => ({
          ...prev,
          [activeDocumentType]: [],
        }))
        setBulkAction(null);

      }
    };

    const openDialog = (type: 'link' | 'unlink') => {
      setBulkAction(prev => type);
      setDisableBulkButtons(prev => ({
        ...prev,
        [activeDocumentType]: true,
      }));
      setIsShowBulkDialog(true);

      setConfirmBulkModalProps(current => {
        return {
          ...current,
          visible: true,
          headerDisplay: displayUnlinkEcmModalHeader,
          confirmationMessageHTML: displayUnlinkEcmModalText(),
          onCancel: () => {
            setConfirmBulkModalProps(initialConfirmationModalValues)
            setDisableBulkButtons(prev => ({
              ...prev,
              [activeDocumentType]: false,
            }));
          },
          onConfirm: () => {
            executeBulkAction("unlink")
          }
        };
      });
    };

    return (
      <>
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>

          {/* UNLINK */}
          <span
            onClick={
              unlinkCount > 0 && !currentDisableBulkButtons
                ? () => openDialog('unlink')
                : undefined
            }
            style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
          >
            <span
              style={{
                opacity: unlinkCount > 0 && !currentDisableBulkButtons ? 1 : 0.5,
                pointerEvents: unlinkCount > 0 && !currentDisableBulkButtons ? 'auto' : 'none',
              }}
            >
              ({unlinkCount})
            </span>
            <span
              className={`${classes['text-btn']} ${classes['unlinkEcm']}`}
              style={{
                opacity: unlinkCount > 0 && !currentDisableBulkButtons ? 1 : 0.5,
                pointerEvents:
                  unlinkCount > 0 && !currentDisableBulkButtons ? 'auto' : 'none',
              }}
            >
              <FontAwesomeIcon className={classes['icons']} icon={faLink} />
              {UnlinkEcmBtnText}
            </span>
          </span>

          {/* LINK */}
          <span
            onClick={
              async () => {
                if (linkCount > 0 && !currentDisableBulkButtons) {
                  executeBulkAction("link")
                }

              }
            }
            style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
          >
            <span
              style={{
                opacity: linkCount > 0 && !currentDisableBulkButtons ? 1 : 0.5,
                pointerEvents: linkCount > 0 && !currentDisableBulkButtons ? 'auto' : 'none',
              }}
            >
              ({linkCount})
            </span>
            <span
              className={`${classes['text-btn']} ${classes['linkToWb']}`}
              style={{
                opacity: linkCount > 0 && !currentDisableBulkButtons ? 1 : 0.5,
                pointerEvents:
                  linkCount > 0 && !currentDisableBulkButtons ? 'auto' : 'none',
              }}
            >
              <FontAwesomeIcon className={classes['icons']} icon={faLink} />
              {LinkToWbBtnText}
            </span>
          </span>
        </div>
      </>
    );
  };


  return (
    <>
      <div
        style={{
          display: props.isDisplayNone ? 'none' : '',
        }}
        className={classes['attachment-container']}
      >
        <div className={classes['attachment-header']}>
          {hasAttachmentLabel && <>Attachments </>}
          <span className={classes['attachment-header-note']}>
            Note: You can drag and drop files inside this panel | Maximum upload file size: (50MB) |
            Allowed File Type: (JPG, JPEG, DOC, DOCX, XLS, XLSX, TXT, BMP, GIF, PDF, PNG, MSG, ZIP)
          </span>
        </div>
        <div className={`${classes['attachment-body']} add-attachment-bulk-body-overrides`}>
          <TabView
            style={{ height: '100%' }}
            activeIndex={activeTabIndex}
            onTabChange={e => {
              setActiveTabIndex(e.index)
              const type = updatedAttachmentTabs.find(x => x.index == e.index)?.id
              setActiveDocumentType(type ?? CertificateDocumentTypeV2.Certificate)
            }}
          >
            {updatedAttachmentTabs.map(tab => (
              <TabPanel
                className="new-cert-prod-dtls-tab-panel"
                header={tab.name}
                key={'tab-panel-' + tab.name}
              >
                <div
                  {...getRootProps({
                    className: `${classes[`attachment-panel-body`]} ${isDragActive && classes[`is-drag-active`]
                      }`,
                  })}
                >
                  {renderDropzoneActive()}
                  {renderAddFileHeader()}

                  <div className={classes['datatable-container']}>
                    <DataTable
                      dataKey="tempUniqueId"
                      rowClassName={getClassForFilesOnEcm}
                      emptyMessage={renderEmptyDatatable()}
                      size="small"
                      value={uploadFileList[tab.id]}
                      columnResizeMode="fit"
                      responsiveLayout="scroll"
                      scrollable
                      selection={selectedAttachment[tab.id] ?? []}
                      onSelectionChange={(e) =>
                        setSelectedAttachment(prev => ({
                          ...prev,
                          [tab.id]: e.value,
                        }))
                      }
                    >
                      {tab.id !== CertificateDocumentTypeV2.InternalFiles && (
                        <Column
                          selectionMode="multiple"
                          style={{ maxWidth: '40px', flex: 'none' }}
                        ></Column>
                      )}
                      <Column
                        style={getColumnWidthStyle(tab.id, {
                          defaultMin: '190px',
                          defaultMax: '190px',
                          r2cInspectionMin: '190px',
                          r2cInspectionMax: '190px',
                        })}
                        header="Document File Name"
                        body={gridFileNameTemplate}
                      ></Column>

                      <Column
                        style={getColumnWidthStyle(tab.id, {
                          defaultMin: '210px',
                          defaultMax: '210px',
                          r2cInspectionMin: '180px',
                          r2cInspectionMax: '180px',
                        })}
                        header={contentTypeHeader}
                        body={gridContentTypeTemplate}
                      ></Column>

                      {(tab.id === CertificateDocumentTypeV2.R2CPackage ||
                        tab.id === CertificateDocumentTypeV2.InspectionSurveillance) && (
                          <Column
                            style={{
                              minWidth: '190px',
                              maxWidth: '190px',
                            }}
                            header={categoryHeader}
                            body={gridCategoryTemplate}
                          ></Column>
                        )}

                      {tab.id != CertificateDocumentTypeV2.InternalFiles && (
                        <Column
                          style={{
                            minWidth: '90px',
                            maxWidth: '90px',
                          }}
                          header={gridHeaderStatusIconTemplate}
                          body={gridStatusIconTemplate}
                        ></Column>
                      )}

                      {tab.id != CertificateDocumentTypeV2.InternalFiles && (
                        <Column
                          style={getColumnWidthStyle(tab.id, {
                            defaultMin: '150px',
                            defaultMax: '150px',
                          })}
                          header="ECM TIC Node ID"
                          body={gridEcmNodeIdTemplate}
                        ></Column>
                      )}

                      {renderDynamicColumns}

                      <Column
                        style={{
                          flexGrow: 1,
                          flexBasis: '170px',
                          width: '170px',
                        }}
                        align="right"
                        header=""
                        body={gridStatusTemplate}
                      ></Column>
                      <Column
                        style={{
                          minWidth: '40px',
                          flex: 'none',
                        }}
                        headerStyle={{ fontWeight: 'normal' }}
                        header={
                          (isEditOrModify || certificateAction.isWithdraw) &&
                            tab.id !== CertificateDocumentTypeV2.R2CPackage &&
                            tab.id !== CertificateDocumentTypeV2.InspectionSurveillance &&
                            tab.id !== CertificateDocumentTypeV2.InternalFiles
                            ? actionHeaderTemplate : null}
                        body={gridActionTemplate}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </TabPanel>
            ))}
          </TabView>
        </div>
      </div>

      <ConfirmationModal
        visible={showDeleteFileConfirmation}
        onCancel={() => setShowDeleteFileConfirmation(false)}
        onConfirm={() => handleDeleteFileToBlobStorage()}
        headerDisplay={'Delete File Confirmation'}
        confirmationMessageHTML={deleteConfirmationMessage()}
        buttonNoDisplay={`No`}
        buttonYesDisplay={`Yes`}
        isSaving={isDeletingInProgress}
      />
      <ConfirmDialog
        style={{ width: '520px' }}
        className="custom-confirm-dialog"
        visible={showMaxFileConfirmation}
        header="Valid File Count Exceeded"
        message={maxFileDialogBody}
        footer={maxFileFooter}
        onHide={() => setShowMaxFileConfirmation(false)}
      />
      {isBulkEditDialogShow && (
        <AddAttachmentBulkCategoryEditDialog
          activeDocumentType={activeDocumentType}
          closeModal={() => setIsBulkEditDialogShow(false)}
          visible={isBulkEditDialogShow}
          selectedRows={selectedAttachment[activeDocumentType] ?? []}
        />
      )}
      <ConfirmationModal {...confirmationModalProps} />
      <ConfirmationModal {...confirmBulkModalProps} />
    </>

  )
}
export default AddAttachmentsBulkV2
